import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    FETCH_BRANCHES_BY_ID
    FETCH_BRANCHES_BY_ID_SUCCESS
    FETCH_BRANCHES_BY_ID_FAILURE

    FETCH_BRANCHES_BY_COORDINATES
    FETCH_BRANCHES_BY_COORDINATES_SUCCESS
    FETCH_BRANCHES_BY_COORDINATES_FAILURE

    SAVE_SELECTED_CITY
    
    SET_SELECTION_TYPE
    SET_SELECTED_BRANCH
    GENERATE_SEARCH_IDENTIFIER_KEY
`,
    {
        prefix: "nearestbranch/"
    }
);
